import {Button, Form, InputNumber, message} from "antd";
import React from "react";
import {MaterialNameFilter} from "../../../../../filters/crm/MaterialName";
import {MaterialPost, MaterialRemove, MaterialUpdate} from "../../../../../models/crm/material";
import _ from 'lodash'
import {EquipRemove} from "../../../../../models/crm/equip";

const FormItem = Form.Item;


class MaterialForm extends React.Component {
    state = {
        data: [],
        update: false,
        btn_text: 'Add Material',
        update_item: null
    };

    handleSubmitMaterial = () => {
        const {data, update, update_item} = this.state;
        this.props.form.validateFields((err, values) => {
            if (!err) {
                if (update)
                    MaterialUpdate(update_item.id, values)
                        .then(response => {
                            const index = _.findIndex(data, {id: update_item.id});
                            data.splice(index, 1, response);
                            this.setState({data, update: false, btn_text: "Add Material", update_item: null});
                            this.props.onChange(data.map(item => item.id));
                            message.success("Material updated successfully");
                            this.resetFields();
                        });
                else
                    MaterialPost(values)
                        .then(response => {
                            data.push(response);
                            this.setState({data, update: false, btn_text: "Add Material", update_item: null});
                            this.props.onChange(data.map(item => item.id));
                            message.success("Material added successfully");
                            this.resetFields()
                        })
            }
        })
    };
    resetFields = () => {
        this.props.form.resetFields();
        this.material_name.handleChange()
    };
    fillUpdateFields = (item) => {
        this.props.form.setFieldsValue({
            quantity: item.quantity,
            custom_cost: item.custom_cost,
        });
        this.material_name.handleChange({key: item.material.id, label: item.material.label});
        this.setState({update: true, btn_text: "Update Material", update_item: item})
    };

    removeData = (item) => {
        const {data} = this.state;
        MaterialRemove(item.id)
            .then(() => {
                message.success("Material Removed");
                _.remove(data, {id: item.id});
                this.props.onChange(data.map(item => item.id));
                this.setState({data})
            })
    };

    render() {
        const {getFieldDecorator} = this.props.form;
        const {data, btn_text} = this.state;
        return (
            <div className="row">
                <div className="col-sm-6 col-12">
                    <div className="floating-label">
                        <FormItem label="Material Name">
                            {getFieldDecorator('material', {
                                rules: [{
                                    required: true,
                                    message: 'Please select material name'
                                }],
                            })(<MaterialNameFilter onRef={ref => (this.material_name = ref)}/>)}
                        </FormItem>
                    </div>
                </div>
                <div className="col-sm-6 col-12">
                    <div className="floating-label">
                        <FormItem label="Quantity">
                            {getFieldDecorator('quantity', {
                                rules: [{
                                    required: true,
                                    message: 'Please enter quantity'
                                }],
                            })(
                                <InputNumber placeholder="Enter Here"/>)}
                        </FormItem>
                    </div>
                </div>
                {data.length < 1 &&
                <div className="col-sm-6 col-12">
                        <div className="floating-label">
                            <FormItem label="Custom Cost ">
                                {getFieldDecorator('custom_cost')(<InputNumber style={{width: '100%'}}/>)}
                            </FormItem>
                        </div>
                    </div>}
                <div className="col-12 add-btn">
                    <Button type="primary" htmlType={"button"} onClick={this.handleSubmitMaterial}>{btn_text}</Button>
                </div>
                {data.length > 0 &&
                <div className="added-serv-record">
                    {data.map((item, index) => {
                        return <div key={index} className="row m-0">
                            <div className="col-12 added-service-info">
                                <Button className="edit-gen-btn delete-red-btn" onClick={() => this.removeData(item)}><i
                                    className="fa fa-trash"/>
                                </Button>
                                <Button className="edit-gen-btn" onClick={() => this.fillUpdateFields(item)}><i className="fa fa-pencil"/></Button>
                                <ul>
                                    <li><span>Material Name:</span>{item.material.label}</li>
                                    <li><span>Quantity:</span> {item.quantity}</li>
                                </ul>
                            </div>
                        </div>
                    })}
                </div>}

            </div>

        )
    }
}

export const Material = Form.create()(MaterialForm);



// WEBPACK FOOTER //
// ./src/pages/crm/proposals/popups/tabs/Material.jsx